import { all, fork } from 'redux-saga/effects';

import watchAuthenticateUser from 'actions/users.jsx';
import workspaceSaga from 'actions/workspace';
import templatesSaga from 'actions/templates';
import storyboardSaga from 'actions/storyboard';
import storyboardListSaga from 'actions/storyboardList'
import fontsSaga from 'actions/fonts';
import pageSaga from 'actions/pages';
import mediaSaga from 'actions/media';
import contentSaga from "actions/content";
import editorSaga from 'actions/editor';
import groupSaga from 'actions/group';
import gatingSaga from 'actions/gating';

import brandKitMediaSaga from 'actions/brandKit/media';
import brandKitIconsSaga from 'actions/brandKit/icons';
import brandKitColorsSaga from 'actions/brandKit/colors';
import brandKitTextSaga from 'actions/brandKit/text';
import brandKitButtonsSaga from 'actions/brandKit/buttons';
import brandKitComponentsSaga from 'actions/brandKit/components';
import brandKitSaga from 'actions/brandKit/brandKit';

import userManagementSaga from 'actions/userManagement'
import userRoleSaga from 'actions/userRoles'
import storyboardReportsSaga from 'actions/storyboardReports';
import liveElementsSaga from 'actions/live_elements.jsx';
import transactionalMetricsSaga from 'actions/transactionalMetrics';
import landingPageReportsSaga from 'actions/landingPageReports';
import interactiveReportSaga from 'actions/interactiveReports';

import contentGridSaga from 'actions/contentGrid';
import contentCardsSaga from 'actions/contentCards';
import layoutManagerSaga from 'actions/layoutManager';

import hubspotSaga from 'actions/integrations/hubspot';
import marketoSaga from 'actions/integrations/marketo';
import integrationSaga from 'actions/integrations/integrations';
import pardotSaga from 'actions/integrations/pardot';
import salesforceSaga from 'actions/integrations/salesforce';
import figmaSaga from 'actions/integrations/figma';
import formsSaga from 'actions/forms/forms';
import hubspotFormsSaga from 'actions/forms/hubspot';
import marketoFormsSaga from 'actions/forms/marketo';
import pardotFormsSaga from 'actions/forms/pardot';
import externalFormSaga from 'actions/forms/external';
import formFieldsSaga from 'actions/formFields';

import gatingConfigurationsSaga from 'actions/gatingConfigurations';
import leadsSaga from 'actions/leads';
import fieldsSaga from 'actions/fields/fields';
import versionsSaga from 'actions/versions';
import aliasesSaga from 'actions/aliases';
import assetAliasesSaga from 'actions/assetAliases';
import paperfliteSaga from 'actions/paperflite';
import lockSaga from 'actions/lock';
import zohoSaga from 'actions/integrations/zoho';
import journeySaga from 'actions/journey';
import mixPanelSaga from 'actions/mixpanel';

import paletteSaga from 'actions/palette';
import workspaceReportSaga from 'actions/workspaceReports';
import variableSaga from 'actions/variables';
import pageHealthSaga from 'actions/pageHealth';
import personalizationSaga from 'actions/personalization';

import mobileOptimizationSaga from 'actions/mobileOptimization';
import promptEditorSaga from 'actions/promptEditor';

export default function* root() {
  yield all([
    fork(watchAuthenticateUser),
    fork(workspaceSaga),
    fork(templatesSaga),
    fork(storyboardSaga),
    fork(aliasesSaga),
    fork(fontsSaga),
    fork(pageSaga),
    fork(mediaSaga),
    fork(brandKitMediaSaga),
    fork(brandKitIconsSaga),
    fork(brandKitColorsSaga),
    fork(brandKitTextSaga),
    fork(brandKitButtonsSaga),
    fork(brandKitComponentsSaga),
    fork(brandKitSaga),
    fork(contentSaga),
    fork(editorSaga),
    fork(groupSaga),
    fork(userManagementSaga),
    fork(userRoleSaga),
    fork(leadsSaga),
    fork(storyboardReportsSaga),
    fork(liveElementsSaga),
    fork(interactiveReportSaga),
    fork(landingPageReportsSaga),
    fork(transactionalMetricsSaga),
    fork(storyboardListSaga),
    fork(gatingSaga),
    fork(contentGridSaga),
    fork(paperfliteSaga),
    fork(contentCardsSaga),
    fork(layoutManagerSaga),
    fork(hubspotSaga),
    fork(journeySaga),
    fork(marketoSaga),
    fork(integrationSaga),
    fork(pardotSaga),
    fork(salesforceSaga),
    fork(zohoSaga),
    fork(figmaSaga),
    fork(formsSaga),
    fork(formFieldsSaga),
    fork(hubspotFormsSaga),
    fork(marketoFormsSaga),
    fork(pardotFormsSaga),
    fork(externalFormSaga),
    fork(gatingConfigurationsSaga),
    fork(fieldsSaga),
    fork(assetAliasesSaga),
    fork(versionsSaga),
    fork(lockSaga),
    fork(mixPanelSaga),
    fork(paletteSaga),
    fork(workspaceReportSaga),
    fork(variableSaga),
    fork(pageHealthSaga),
    fork(personalizationSaga),
    fork(mobileOptimizationSaga),
    fork(promptEditorSaga)
  ]);
}